import { BaseEntity } from "yt-ng-framework";

export class Company extends BaseEntity{
    constructor(){
        super();
    }
    
    Naziv: string = null;
    SNaziv: string = null;
    Pib: string  = null;
    MaticniBroj: string  = null;
    Adresa: string  = null;
    MestoID: number  = null;
    OdgovornoLiceID: number  = null;
    RegistarskiBroj: string  = null;
    SifraDelatnosti: string  = null;
    Web: string = null;
    Napomena: string = null;
    LanguageID: number  = null;
    LogoUrl: string  = null;
    TipKomitentaID: number = 1;
    PdvUSistemu: boolean = false;
    PdvBroj: string = '';
    Jmbg: string = '';
    BrojGazdinstva: string = '';
    Jbkjs:string = null;
    PoreskoOslobodjenjeID : number = null;
    DrzavaID : number = null;
    ValutaID: number = null;
    Gln: string = null;

    Deserialize(input: any){
        // super.Deserialize(input);
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;        
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;     
        this.OdgovornoLiceID = input.OdgovornoLiceID;
        this.RegistarskiBroj = input.RegistarskiBroj;
        this.SifraDelatnosti = input.SifraDelatnosti;
        this.Web = input.Web;
        this.Napomena = input.Napomena;
        this.LanguageID = input.LanguageID;
        this.LogoUrl = input.LogoUrl;
        this.TipKomitentaID = input.TipKomitentaID;
        this.PdvUSistemu = input.PdvUSistemu;
        this.PdvBroj = input.PdvBroj;
        this.Jmbg = input.Jmbg;
        this.BrojGazdinstva = input.BrojGazdinstva;
        this.Jbkjs = input.Jbkjs;
        this.PoreskoOslobodjenjeID = input.PoreskoOslobodjenjeID;
        this.DrzavaID = input.DrzavaID;
        this.ValutaID = input.ValutaID;
        this.Gln = input.Gln;
        return this;
    }
    
    Serialize(input: Company){
        return input;
    }
}